import { gql } from '@apollo/client'

const ALL_PROGRAM_FILTER_CATEGORY_MAPS = gql`
  query ProgramFilterCategoryMapsQuery {
    programFilterCategoriesMaps_LAS (limit: 20000) {
      _id
      id
      filterCategoryId
      programId
    }
  }
`

export { ALL_PROGRAM_FILTER_CATEGORY_MAPS }
